import Vue from "vue";
import App from "./App.vue";

const element = document.getElementById("newsList");

if (element) {
  Vue.config.productionTip = false;

  new Vue({
    render: createElement => {
      const context = {
        props: { ...element.dataset }
      };
      return createElement(App, context);
    }
  }).$mount("#newsList");
}
